export const closeMailViewer = viewer => ({
  type: "CLOSE_MAIL_VIEWER",
  viewer
});

export const openMailViewer = viewer => ({
  type: "OPEN_MAIL_VIEWER",
  viewer
});

export const setCurrentMail = media => ({
  type: "SET_CURRENT_MAIL_VIEWER",
  media: media
});

export const fetchSingleMail = resp => {
  return {
    type: "FETCH_SINGLE_MAIL",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/mail-viewer.js